import { differenceInHours, differenceInMinutes, format, formatDistanceStrict } from 'date-fns';
import { ru } from 'date-fns/locale';

export const getUserStatusDiff = (lastActionDatetime: string): string => {
  const dateNow: Date = new Date();
  const formattedIsoDate: Date = new Date(lastActionDatetime);

  const minutesNumber: number = differenceInMinutes(dateNow, formattedIsoDate, { roundingMethod: 'floor' });
  const hoursNumber: number = differenceInHours(dateNow, formattedIsoDate, { roundingMethod: 'floor' });

  // Если был в сети в течение 10 прошлых минут: "В сети"
  if (minutesNumber <= 10) {
    return 'В сети';
  }

  // До одного часа: Не в сети N минут
  if (minutesNumber > 10 && minutesNumber < 60) {
    const date = formatDistanceStrict(dateNow, formattedIsoDate, { locale: ru, roundingMethod: 'floor' });

    return `Не в сети ${date}`; // минут
  }

  // Больше одного часа: Не в сети N часов
  if (hoursNumber >= 1 && hoursNumber < 24) {
    const date = formatDistanceStrict(dateNow, formattedIsoDate, { locale: ru, roundingMethod: 'floor' });

    return `Не в сети ${date}`; // часов
  }

  // Больше одного дня: Не в сети больше суток
  if (hoursNumber >= 24 && hoursNumber < 48) {
    return 'Не в сети больше суток';
  }

  // Больше двух дней: Не в сети c дд.мм.гг
  if (hoursNumber >= 48) {
    const date = format(formattedIsoDate, 'dd.MM.yyyy');

    return `Не в сети c ${date}`;
  }

  return '';
};
